export default {
    "de": {
        "common": {
            "no-value": "Keine Angabe",
            "no-items": "Keine Einträge",
            "choose": "Auswählen",
            "choose_please": "Bitte wählen",
            "yes": "Ja",
            "no": "Nein",
            "search": "Suche",
            "open": "Offen",
            "calendar_week": "KW",
            "quarter": "Q",
            "time_units": {
                "long": {
                    "1": "Minute|Minuten",
                    "2": "Stunde|Stunden",
                    "3": "Tag|Tage"
                },
                "short": {
                    "1": "Min",
                    "2": "Std",
                    "3": "T"
                }
            },
            "response_codes": {
                "403": "Vorgang nicht erlaubt",
                "500": "Ein unerwarteter Fehler ist aufgetreten (Fehler 500)"
            }
        },
        "nav": {
            "installations": "Montagen",
            "planning": "Planung",
            "service_contracts": "Serviceaufträge",
            "job_messages": "Meldungen",
            "technicians": "Monteure",
            "users": "Benutzer",
            "settings": "Einstellungen"
        },
        "buttons": {
            "cancel": "Abbrechen",
            "confirm": "Bestätigen",
            "close": "Schließen",
            "save": "Speichern",
            "download": "Herunterladen",
            "send": "Absenden",
            "back": "Zurück",
            "delete": "Löschen"
        },
        "popups": {
            "confirm": {
                "title": "Bestätigen"
            }
        },
        "page_titles": {
            "profile": "Mein Profil",
            "users": "Benutzer",
            "technicians": "Monteure",
            "messages": "Meldungen",
            "settings": "Einstellungen"
        },
        "components": {
            "notifications": {
                "header": "Keine Nachrichten | 1 neue Nachricht | {count} neue Nachrichten",
                "buttons": {
                    "remove_item": {
                        "title": "Nachricht löschen"
                    }
                }
            }
        }
    },
    "en": {
        "common": {
            "no-value": "Not set",
            "no-items": "No items",
            "choose": "Choose",
            "choose_please": "Please choose",
            "yes": "Yes",
            "no": "No",
            "search": "Search",
            "open": "Open",
            "calendar_week": "CW",
            "quarter": "Q",
            "time_units": {
                "long": {
                    "1": "Minute|Minutes",
                    "2": "Hour|Hours",
                    "3": "Day|Days"
                },
                "short": {
                    "1": "Min",
                    "2": "Hrs",
                    "3": "D"
                }
            },
            "response_codes": {
                "403": "Operation forbidden"
            }
        },
        "nav": {
            "installations": "Installations",
            "planning": "Planning",
            "service_contracts": "Service Contracts",
            "technicians": "Technicians",
            "settings": "Settings"
        },
        "buttons": {
            "cancel": "Cancel",
            "confirm": "Confirm",
            "close": "Close",
            "save": "Save",
            "download": "Download",
            "send": "Send"
        },
        "popups": {
            "confirm": {
                "title": "Confirm"
            }
        },
        "page_titles": {
            "profile": "My Profile",
            "users": "User",
            "technicians": "Technicians",
            "settings": "Settings",
            "jobs": {
                "assembling": {
                    "edit": "Montage erstellen",
                    "show": "Montage"
                },
                "servicing": {
                    "edit": "Service erstellen",
                    "show": "Service"
                }
            }
        }
    }
}
